<template>
  <div>
    <el-dialog
        title="Thay đổi trường"
        :visible.sync="dialogVisible"
        width="1000px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="5vh"
        custom-class="change-school-dialog"
    >
      <div class="change-school-content">
        <div class="school-panel">
          <div class="school-panel-head">
            <div class="panel-icon">
              <i class="el-icon-office-building"></i>
            </div>
            <div class="panel-text">
              <p class="panel-title">Chọn trường làm việc</p>
              <p class="panel-subtitle">Chọn một trường trong danh sách bên dưới để chuyển phiên làm việc hiện tại.</p>
            </div>
          </div>

          <div class="school-table-wrapper">
            <div class="school-filter-bar">
              <el-input
                v-model="filterText"
                placeholder="Tìm trường theo tên hoặc mã"
                clearable
                prefix-icon="el-icon-search"
                @clear="onFilterClear"
              ></el-input>
            </div>
            <el-table
                ref="multipleTable"
                class="school-table"
                :empty-text="textTable"
                v-loading="loadingData"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255, 0)"
                :data="displayedList"
                :row-class-name="rowClassName"
                highlight-current-row
                :header-cell-style="tableHeaderColor"
                :max-height="$tableMaxHeightSmallMini"
                border
            >
              <el-table-column
                  type="index"
                  label="STT"
                  width="60"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="fullName"
                  label="Họ tên"
                  min-width="170"
              ></el-table-column>
              <el-table-column
                  prop="phone"
                  align="center"
                  label="Số điện thoại"
                  width="140"
              ></el-table-column>
              <el-table-column
                  prop="school.id"
                  align="center"
                  label="Code"
                  width="110"
              ></el-table-column>
              <el-table-column
                  prop="school.schoolName"
                  label="Tên trường"
                  min-width="240"
              >
                <template #default="scope">
                  <div class="school-name-cell">
                    <div class="school-name-row">
                      <span class="school-name">{{ scope.row.school.schoolName }}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="160" align="center" label="Lựa chọn">
                <template #default="scope">
                  <el-button
                    class="select-button"
                    :type="scope.row.school && scope.row.school.status ? 'primary' : 'default'"
                    :plain="!scope.row.school || !scope.row.school.status"
                    size="small"
                    @click="changeSchoolMethod(scope.row)"
                  >
                    {{ scope.row.school && scope.row.school.status ? 'Đã chọn' : 'Chọn' }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer change-school-footer">
        <el-button class="btn-cancel" type="danger" size="medium" @click="closeDialogByButton()">
          <i class="el-icon-circle-close" />
          <span>{{ $t("button.close") }}</span>
        </el-button>
        <el-button
            class="btn-save"
            type="success"
            size="medium"
            @click="submitForm()"
            :loading="loadingButton"
        >
          <i class="el-icon-circle-check" />
          <span>{{ $t("button.save") }}</span>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CommonOnekidsService from "@/services/CommonService/CommonOnekidsService";
export default {
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      textTable: "",
      loadingData: true,
      checkSchool: true,
      responseList: [],
      filterText: '',
      loadingButton: false,
      rules: {
        newPhone: [
          {
            min: 10,
            max: 10,
            message: "Số điện thoại bao gồm 10 số",
            trigger: "change",
          },
          {
            required: true,
            message: "Số điện thoại không được để trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    tableHeaderColor() {
      return "background-color: #ECFDF5; color: #1e4933; font-weight: 700;";
    },
    rowClassName({row}) {
      return row && row.school && row.school.status ? 'table-row-selected' : '';
    },
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      // this.resetFormData();
    },
    //click when click button
    closeDialogByButton() {
      this.$emit("dialog-close");
      // this.resetFormData();
    },
    resetFormData() {
      setTimeout(() => {
        this.$refs["userData"].resetFields();
      }, 200);
    },
    changeSchoolMethod(row) {
      this.responseList.forEach((x) => {
        x.school.status = false;
      });
      row.school.status = true;
      this.checkSchool = true;
    },
    submitForm() {
      let schoolSchoose = this.responseList.filter((x) => x.school.status);
      let idSchool = schoolSchoose[0].school.id;
      this.loadingButton = true;
      CommonOnekidsService.updateEmployeeInEmployee(idSchool)
          .then((resp) => {
            let responseData = resp.data.data;
            localStorage.setItem("user", JSON.stringify(responseData));
            this.$message({
              message: "Thay đổi thành công",
              type: "success",
            });
            this.$store.dispatch("auth/setUserActions", responseData);
            this.$router.push("/dashboard");
            this.$store.dispatch("notificationNavbarStore/fetchNotification");
            setTimeout(() => {
              this.closeDialogByButton();
            }, 500);
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            setTimeout(() => {
              this.$store.commit('layout/reload_dashboard')
              this.loadingButton = false;
            }, 500);
          });
    },

    getChangeSchoolInitialData() {
      this.loadingData = true;
      CommonOnekidsService.findInfoEmployeeInEmployee()
          .then((resp) => {
            this.responseList = resp.data.data || [];
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            if (this.responseList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
    },
        onFilterClear() {
          this.filterText = '';
        },
  },
      computed: {
        displayedList() {
          if (!this.responseList) return [];
          // filter by name or code
          const q = this.filterText ? this.filterText.toString().trim().toLowerCase() : '';
          let list = this.responseList.slice();
          if (q) {
            list = list.filter((r) => {
              const name = (r.school && r.school.schoolName ? r.school.schoolName : '') || '';
              const code = (r.school && r.school.id ? String(r.school.id) : '');
              return name.toLowerCase().includes(q) || code.toLowerCase().includes(q);
            });
          }
              // sort so that currently selected school(s) appear first, then by school.id ascending
              list.sort((a, b) => {
                const aSelected = a.school && a.school.status;
                const bSelected = b.school && b.school.status;
                if (aSelected && !bSelected) return -1;
                if (!aSelected && bSelected) return 1;
                const ai = a.school && a.school.id ? Number(a.school.id) : NaN;
                const bi = b.school && b.school.id ? Number(b.school.id) : NaN;
                if (!isNaN(ai) && !isNaN(bi)) return ai - bi;
                const as = a.school && a.school.id ? String(a.school.id) : '';
                const bs = b.school && b.school.id ? String(b.school.id) : '';
                return as.localeCompare(bs);
              });
          return list;
        },
      },
      mounted() {
        // ensure any previously selected row gets highlighted on open
      },
};
</script>

<style lang="scss" scoped>
.change-school-content {
  padding: 4px 0 6px;
}

.school-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px;
}

.school-panel-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 18px;
}

.panel-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #60a5fa, #2563eb);
  color: #ffffff;
  font-size: 18px;
  flex-shrink: 0;
}

.panel-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.panel-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.school-table-wrapper {
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.school-name-cell {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.school-name {
  font-weight: 600;
  color: #1e293b;
}

.school-code {
  font-size: 12px;
  color: #94a3b8;
}

.change-school-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.table-row-selected > td {
  background: #e6f2ff !important;
}

.select-button {
  min-width: 100px;
  border-radius: 10px;
  font-weight: 600;
}

.school-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.active-badge {
  margin-left: 8px;
}

/deep/.change-school-dialog {
  border-radius: 20px;
  overflow: hidden;
}

/deep/.change-school-dialog .el-dialog__header {
  padding: 18px 22px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

/deep/.change-school-dialog .el-dialog__body {
  padding: 18px 22px 8px;
}

/deep/.change-school-dialog .el-dialog__footer {
  padding: 10px 22px 20px;
}

/deep/.el-dialog__title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
}

/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/deep/.school-table th,
/deep/.school-table td {
  padding: 10px 0;
}

/* ensure header uses soft green background as well (fallback) */
/deep/.school-table thead th {
  background: #ECFDF5 !important;
  color: #1e4933 !important;
}

/deep/.school-table::before {
  display: none;
}

/deep/.school-table .el-table__row:hover > td {
  background: #f8fbff !important;
}

/deep/.school-radio .el-radio__label {
  font-weight: 600;
  color: #334155;
}

/deep/.school-radio.is-checked .el-radio__label {
  color: #2563eb;
}

/deep/.btn-cancel,
/deep/.btn-save {
  min-width: 110px;
  border-radius: 10px;
}
</style>
